document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.getElementById("preloader");
  if (!preloader) return;

  const duration = parseFloat(preloader.dataset.duration || 1) * 1000;

  // Lock scrolling while preloader is visible
  document.body.style.overflow = "hidden";

  window.addEventListener("load", () => {
    setTimeout(() => {
      // Trigger CSS fade-out
      preloader.classList.add("is-hidden");

      // Remove after the fade-out duration (0.6s)
      setTimeout(() => {
        preloader.style.display = "none";
        document.body.style.overflow = ""; // restore scrolling
      }, 600);
    }, duration);
  });
});
